export default {
  SET_CURRENT_USER: (state, userData) => {
    state.currentUser = userData;
  },
  SET_USERS: (state, users) => {
    const filteredUsers = users.filter(
      (user) => user._id !== process.env.VUE_APP_OIL_USER_EMAIL
    );
    state.users = filteredUsers;
  },
  SET_USERS_PENDING_APPROVAL: (state, users) => {
    state.usersPendingApproval = users;
  },
  SET_USERS_LOGGED_IN_TODAY: (state, users) => {
    state.usersLoggedInToday = users;
  },
  SET_USERS_REJECTED: (state, users) => {
    state.usersRejected = users;
  },
  SET_USERS_WITHOUT_SEPIA_INFO: (state, users) => {
    state.usersWithoutSepiaInfo = users;
  },
};
